import { createRegisteredPastEventsQuery } from "@api/solid-query/event";
import type { PlayablePastEventModel } from "@road-rally/backend-api/backend-types";
import { For, createMemo } from "solid-js";
import PastEventCard from "./PastEventCard";

export const PastEventList = (props: { events: PlayablePastEventModel[] }) => {
  const registeredEventsQuery = createRegisteredPastEventsQuery();
  const registeredEventIds = createMemo(
    () => new Set(registeredEventsQuery.data ?? [])
  );

  return (
    <div class="mt-4 w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      <For each={props.events}>
        {(event) => {
          return (
            <PastEventCard
              id={event.id}
              photoSRC={event.image}
              title={event.name}
              location={event.city + ", " + event.state + " " + event.country}
              registered={[...registeredEventIds().values()].some(
                (r) => r.id === event.id
              )}
            />
          );
        }}
      </For>
    </div>
  );
};

export default PastEventList;
